import {graphql} from 'react-relay'
import type {GraphQLTaggedNode} from 'react-relay'

export const agentFragment: GraphQLTaggedNode = graphql`
  fragment AssignAgentsDialogAgentFragment on Agent {
    id
    name
    connected
    enabled
    environment {
      os {
        type
      }
    }
  }
`

export const assignableAgentPoolItemsQuery: GraphQLTaggedNode = graphql`
  query AssignAgentsDialogAssignablePoolItemsQuery($agentPoolId: ID!) {
    agentPool(id: $agentPoolId) {
      id
      rawId
      name
      maxAgentsNumber
      ... on AgentPool {
        assignableCloudImages {
          edges {
            node {
              id
              rawId
              name
              agentTypeRawId
              agentPool {
                id
                rawId
                name
              }
              instances {
                count
              }
            }
          }
        }
        assignableAgents {
          edges {
            node {
              id
              rawId
              name
              authorized
              enabled
              connected
              agentPool {
                id
                rawId
                name
              }
              environment {
                os {
                  type
                }
              }
              ...AssignAgentsDialogAgentFragment
            }
          }
        }
      }
    }
  }
`

export const bulkMoveItemsToAgentPool: GraphQLTaggedNode = graphql`
  mutation AssignAgentsDialogBulkMoveItemsToAgentPoolMutation(
    $agentTypeRawIds: [ID!]!
    $authorizedAgentRawIds: [ID!]!
    $unauthorizedAgentRawIds: [ID!]!
    $agentPoolRawId: ID!
  ) {
    bulkMoveCloudImagesToAgentPool(
      input: {agentTypeRawIds: $agentTypeRawIds, targetAgentPoolRawId: $agentPoolRawId}
    ) {
      targetAgentPool {
        id
      }
    }
    bulkMoveAgentsToAgentPool(
      input: {agentRawIds: $authorizedAgentRawIds, targetAgentPoolRawId: $agentPoolRawId}
    ) {
      targetAgentPool {
        id
      }
    }
    bulkAuthorizeAgents(
      input: {agentRawIds: $unauthorizedAgentRawIds, targetAgentPoolRawId: $agentPoolRawId}
    ) {
      agents {
        id
      }
    }
  }
`
